import { connect, MapStateToProps } from 'react-redux';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { threadUpdated } from '@wix/da-shared-react/pkg/CommentThread/actionCreators';
import { getStreamId } from '@wix/da-shared-react/pkg/CommentThread/helpers';
import { getThreadState } from '@wix/da-shared-react/pkg/CommentThread/selectors';
import { AppState } from '../../../types/store';
import { CommentsState } from '../../../types/comments';
import CommentPage, { Props } from './CommentPage';

export type StateProps = Pick<
  Props,
  | 'top'
  | 'item'
  | 'itemId'
  | 'typeId'
  | 'parent'
  | 'commentId'
  | 'currentUser'
  | 'canPostComment'
>;
export type OwnProps = Omit<Props, keyof StateProps>;
export type DispatchProps = Pick<Props, 'onThreadUpdated'>;
const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const {
    top,
    item,
    typeId,
    itemId,
    commentId,
    editId,
    parent,
    parentHistory,
  } = state.comments as CommentsState;
  const { canPostComment } = getThreadState(state, typeId, itemId);
  return {
    top,
    item,
    itemId,
    editId,
    typeId,
    parent,
    commentId,
    streamId: getStreamId(typeId, itemId),
    currentUser: getCurrentUser(state),
    parentHistory,
    canPostComment,
  };
};

const mapDispatchToProps: DispatchProps = {
  onThreadUpdated: threadUpdated,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentPage);
